import {
  GetJourneyPricingQuery,
  CheckoutUserFragment,
  ConsultationFragment,
  GetSubscriptionPricingQuery,
  ActiveSubscriptionsFragment,
  GetDisplayedProductsQuery
} from "./generated"

export * from "./generated"

/**
 * Set of compatibility types while migrating from old graphql codegen tool
 * We should move these to fragments.
 * See: https://github.com/dotansimha/graphql-code-generator/issues/1904#issuecomment-508528504
 */
export type GetPricingPricing = NonNullable<NonNullable<GetJourneyPricingQuery["currentLead"]>["pricing"]>
export type GetPricingLineItems = NonNullable<GetPricingPricing["lineItems"]>[0]
export type GetPricingProduct = NonNullable<GetPricingLineItems["product"]>
export type CheckoutUserFragmentStripeCards = NonNullable<NonNullable<CheckoutUserFragment>["stripeCards"]>[0]
export type CheckoutUserFragmentAddress = NonNullable<NonNullable<CheckoutUserFragment>["address"]>
export type CheckoutUserFragmentPhone = NonNullable<NonNullable<CheckoutUserFragment>["phone"]>
export type ConsultationFragmentConsultation = NonNullable<NonNullable<ConsultationFragment>["consultation"]>
export type ConsultationFragmentDoctorMessageDisplayed = NonNullable<
  NonNullable<ConsultationFragmentConsultation>["doctorMessageDisplayed"]
>
export type ConsultationFragmentConsultationMessages = NonNullable<
  ConsultationFragmentConsultation["consultationMessages"]
>[0]
export type ConsultationFragmentDoctor = NonNullable<ConsultationFragmentConsultation["doctor"]>
export type GetSubscriptionPricingUser = NonNullable<GetSubscriptionPricingQuery["currentUser"]>
export type GetSubscriptionPricingActiveSubscriptions = NonNullable<
  GetSubscriptionPricingUser["activeSubscriptions"]
>[0]
export type GetSubscriptionPricingLineItems = NonNullable<
  NonNullable<GetSubscriptionPricingActiveSubscriptions["pricing"]>["lineItems"]
>[0]
export type ActiveSubscriptionsFragmentActiveSubscriptions = NonNullable<
  ActiveSubscriptionsFragment["activeSubscriptions"]
>[0]
export type ActiveSubscriptionsFragmentActiveProducts = NonNullable<
  ActiveSubscriptionsFragment["activeSubscriptions"][0]["activeProducts"]
>[0]

export type GetDisplayedProductsDisplayedProducts = NonNullable<GetDisplayedProductsQuery["displayedProducts"]>[0]

/** Strangely in use by datetime-picker */
export type Date = any
